import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "@/components/home/HomePage.vue";

import AboutPage from "@/components/about/AboutPage.vue";
import IntroductionPage from "@/components/about/IntroductionPage.vue";
import HistoryPage from "@/components/about/HistoryPage.vue";
import TeamPage from "@/components/about/TeamPage.vue";
import OrganizationPage from "@/components/about/OrganizationPage.vue";

import DepartmentPage from "@/components/department/DepartmentPage.vue";
import QuantumMaterialDesignAndPredictionResearchPage from "@/components/department/QuantumMaterialDesignAndPredictionResearchPage.vue";
import QuantumMaterialPreparationResearchPage from "@/components/department/QuantumMaterialPreparationResearchPage.vue";
import QuantumPhysicalPropertyDetectionAndRegulationResearchPage from "@/components/department/QuantumPhysicalPropertyDetectionAndRegulationResearchPage.vue";
import QuantumDeviceProcessingAndTestingResearchPage from "@/components/department/QuantumDeviceProcessingAndTestingResearchPage.vue";

import PeoplePage from "@/components/people/PeoplePage.vue";
import ExpertPage from "@/components/people/ExpertPage.vue";
import ResearcherPage from "@/components/people/ResearcherPage.vue";
import AdministratorPage from "@/components/people/AdministratorPage.vue";
import PeopleDetailPage from "@/components/people/PeopleDetail.vue";

import FacilityPage from "@/components/facility/FacilityPage.vue";
import FacilityListPage from "@/components/facility/FacilityListPage.vue";
import FacilityDetailPage from "@/components/facility/FacilityDetailPage.vue";

import ResearchPage from "@/components/research/ResearchPage.vue";
import ProjectPage from "@/components/research/ProjectPage.vue";
import PublicationListPage from "@/components/research/PublicationListPage.vue";
import PublicationDetailPage from "@/components/research/PublicationDetailPage.vue";

import NewsPage from "@/components/news/NewsPage.vue";
import NewsListPage from "@/components/news/NewsListPage.vue";
import NewsDetailPage from "@/components/news/NewsDetailPage.vue";

import AnnouncementPage from "@/components/announcement/AnnouncementPage.vue";
import AnnouncementListPage from "@/components/announcement/AnnouncementListPage.vue";
import AnnouncementDetailPage from "@/components/announcement/AnnouncementDetailPage.vue";

import CollaborationPage from "@/components/collaboration/CollaborationPage.vue";
import CollaborationProgramPage from "@/components/collaboration/CollaborationProgramPage.vue";
import CollaborationConferencePage from "@/components/collaboration/CollaborationConferencePage.vue";
import CollaborationDetailPage from "@/components/collaboration/CollaborationDetailPage.vue";

import JoinUsPage from "@/components/join-us/JoinUsPage.vue";
import ContactUsPage from "@/components/contact-us/ContactUsPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: HomePage,
  },
  {
    path: "/about",
    component: AboutPage,
    redirect: "/about/introduction",
    children: [
      {
        path: "introduction",
        component: IntroductionPage,
      },
      {
        path: "history",
        component: HistoryPage,
      },
      {
        path: "team",
        component: TeamPage,
      },
      {
        path: "organization",
        component: OrganizationPage,
      },
    ],
  },
  {
    path: "/department",
    component: DepartmentPage,
    redirect: "/department/quantum-material-design-and-prediction-research",
    children: [
      {
        path: "quantum-material-design-and-prediction-research",
        component: QuantumMaterialDesignAndPredictionResearchPage,
      },
      {
        path: "quantum-material-preparation-research",
        component: QuantumMaterialPreparationResearchPage,
      },
      {
        path: "quantum-physical-property-detection-and-regulation-research",
        component: QuantumPhysicalPropertyDetectionAndRegulationResearchPage,
      },
      {
        path: "quantum-device-processing-and-testing-research",
        component: QuantumDeviceProcessingAndTestingResearchPage,
      },
    ],
  },
  {
    path: "/people",
    component: PeoplePage,
    redirect: "/people/expert",
    children: [
      {
        path: "expert",
        component: ExpertPage,
      },
      {
        path: "researcher",
        component: ResearcherPage,
      },
      {
        path: "administrator",
        component: AdministratorPage,
      },
      {
        path: "detail",
        component: PeopleDetailPage,
      },
    ],
  },
  {
    path: "/facility",
    component: FacilityPage,
    redirect: "/facility/list",
    children: [
      {
        path: "list",
        component: FacilityListPage,
      },
      {
        path: "detail",
        component: FacilityDetailPage,
      },
    ],
  },
  {
    path: "/research",
    component: ResearchPage,
    redirect: "/research/project",
    children: [
      {
        path: "project",
        component: ProjectPage,
      },
      {
        path: "publication",
        component: PublicationListPage,
      },
      {
        path: "publication/detail",
        component: PublicationDetailPage,
      },
    ],
  },
  {
    path: "/news",
    component: NewsPage,
    redirect: "/news/list",
    children: [
      {
        path: "list",
        component: NewsListPage,
      },
      {
        path: "detail",
        component: NewsDetailPage,
      },
    ],
  },
  {
    path: "/announcement",
    component: AnnouncementPage,
    redirect: "/announcement/list",
    children: [
      {
        path: "list",
        component: AnnouncementListPage,
      },
      {
        path: "detail",
        component: AnnouncementDetailPage,
      },
    ],
  },
  {
    path: "/collaboration",
    component: CollaborationPage,
    redirect: "/collaboration/project",
    children: [
      {
        path: "project",
        component: CollaborationProgramPage,
      },
      {
        path: "conference",
        component: CollaborationConferencePage,
      },
      {
        path: "detail",
        component: CollaborationDetailPage,
      },
    ],
  },
  {
    path: "/join-us",
    component: JoinUsPage,
  },
  {
    path: "/contact-us",
    component: ContactUsPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
});

export default router;
